import { render, staticRenderFns } from "./StmtTypeByDebtTypeSHelplist.vue?vue&type=template&id=23c5ff11&"
import script from "./StmtTypeByDebtTypeSHelplist.vue?vue&type=script&lang=js&"
export * from "./StmtTypeByDebtTypeSHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports